import React from 'react';
import { SUPPORTED_CRYPTOS } from '../services/api';

// Component for managing crypto assets
const CryptoAssetsList = ({ assets, onAssetChange, onAddAsset, onRemoveAsset }) => {
  // Handle change in crypto selection
  const handleCryptoChange = (index, value) => {
    const updatedAssets = [...assets];
    updatedAssets[index] = { ...updatedAssets[index], crypto: value };
    onAssetChange(updatedAssets);
  };

  // Handle change in amount
  const handleAmountChange = (index, value) => {
    // Validate input to ensure it's a positive number
    if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
      const updatedAssets = [...assets];
      updatedAssets[index] = { ...updatedAssets[index], amount: value };
      onAssetChange(updatedAssets);
    }
  };

  return (
    <div className="crypto-assets-list">
      <h3>Step 2: Enter Your Crypto Holdings</h3>
      
      {assets.map((asset, index) => (
        <div key={index} className="asset-row">
          <div className="form-group">
            <select
              value={asset.crypto}
              onChange={(e) => handleCryptoChange(index, e.target.value)}
              className="form-control"
            >
              <option value="">Select Cryptocurrency</option>
              {SUPPORTED_CRYPTOS.map((crypto) => (
                <option key={crypto.id} value={crypto.id}>
                  {crypto.name} ({crypto.symbol})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <input
              type="text"
              value={asset.amount}
              onChange={(e) => handleAmountChange(index, e.target.value)}
              placeholder="Amount"
              className="form-control"
            />
          </div>
          
          {assets.length > 1 && (
            <button 
              type="button" 
              onClick={() => onRemoveAsset(index)}
              className="btn btn-danger"
            >
              Remove
            </button>
          )}
        </div>
      ))}
      
      <button 
        type="button" 
        onClick={onAddAsset}
        className="btn btn-primary"
      >
        Add Asset
      </button>
    </div>
  );
};

export default CryptoAssetsList;